import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import * as React from 'react';
import ReactGA from 'react-ga';
import Routes from './Routes';
import ApplicationInsightService from './shared-services/ApplicationInsight/ApplicationInsightService';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

const customWindow: ICustomWindow = window;

const App = () => {
  ReactGA.initialize('UA-38298106-1', { debug: false });
  ApplicationInsightService.initialize();
  dayjs.extend(utc);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Routes
        contextRoot={
          customWindow.location.host === 'localhost:5001'
            ? '/'
            : customWindow.initialAppState.pathContext
        }
        federationProvider={customWindow.initialAppState.federationProvider}
      />
    </LocalizationProvider>
  );
};

export default App;
